import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { UserIcon, DropdownIcon } from "../../../assets/icons/index.jsx";

export default function UserDropdown({ onLogout }) {
    const { user } = useSelector((state) => state.auth);
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // ✅ close when clicking outside
    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const menuItems = [
        { label: "My Orders", icon: "📦", href: "/orders" },
        { label: "Wishlist", icon: "🤍", href: "/wishlist" },
        { label: "Profile", icon: "👤", href: "/profile" },
    ];

    return (
        <div ref={ref} className="items-center relative">

            {/* Trigger */}
            <button
                onClick={() => setOpen(p => !p)}
                className="flex items-center text-[var(--text-light)]"
            >
                <UserIcon size={22} />

                <span className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`}>
                    <DropdownIcon size={14} />
                </span>
            </button>

            {/* Dropdown */}
            <div className={`absolute top-full right-0 mt-3 w-52 bg-white rounded-2xl shadow-xl z-[99]
                transition-all duration-200 ease-in-out overflow-hidden
                ${open
                    ? "opacity-100 visible translate-y-0"
                    : "opacity-0 invisible -translate-y-1"
                }`}
            >
                {/* User info */}
                <div className="px-4 py-3 border-b border-gray-100">
                    <p className="text-sm font-semibold text-black">{user?.username}</p>
                </div>
                {/* Menu items */}
                <ul className="py-2">

                    {menuItems.map((item) => (
                        <li key={item.label}>

                            <a href={item.href}
                                onClick={() => setOpen(false)}
                                className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-[var(--primary-extrasoft)] transition-colors"
                            >
                                {item.label}
                            </a>
                        </li>
                    ))}
                </ul>

                {/* Logout */}
                <div className="border-t border-gray-100 py-2">
                    <button
                        onClick={() => { setOpen(false); onLogout(); }}
                        className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 transition-colors"
                    >
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
}